import { render } from "./NewFriendlyGame.vue?vue&type=template&id=62f9becf"
import script from "./NewFriendlyGame.vue?vue&type=script&lang=js"
export * from "./NewFriendlyGame.vue?vue&type=script&lang=js"

import "./NewFriendlyGame.vue?vue&type=style&index=0&id=62f9becf&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__